import { grey } from "@material-ui/core/colors"

export const colors={
            grayBackground:grey[200],
            textSecundary: grey[700] 
}